import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";
import {SirenPortalBranding} from "./useGetSirenPortalBrandings";

export type SirenPortalBrandingInput = {
    clientID?: string;
    domains: string[];
    disableDefaultStyle: boolean;
    theme: string;
    customCSS: string;
    pageTitle: string;
    cspImgSrc: string[];
    cspFontSrc: string[];
    cspStyleSrc: string[];
};

export function useUpsertSirenPortalBranding() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const save = useCallback(async (input: SirenPortalBrandingInput, id?: string): Promise<SirenPortalBranding> => {
        setSaving(true);
        setError(null);
        try {
            if (id) {
                const res = await platformAPI.patch<SirenPortalBranding>(`api/siren/branding/${id}`, input);
                return res.data;
            } else {
                const res = await platformAPI.post<SirenPortalBranding>("api/siren/branding", input);
                return res.data;
            }
        } catch (e) {
            if (isAxiosError(e) && e?.response?.data?.error) {
                setError(e.response.data.error);
            } else {
                setError("Failed to save siren branding");
            }
            throw e;
        } finally {
            setSaving(false);
        }
    }, []);

    return {save, saving, error};
}
